
import { useState, useEffect, useContext, createContext } from "react";

import { fetchPortfolioData } from "../utilities/server-fetch";

import { reportInteraction } from "../utilities/server-update-analytics";



export {
  PortfolioContextProvider,
  usePortfolio, usePortfolioUpdate
};


const PortfolioContext = createContext<any>( null ); // TODO: Properly fill out

const PortfolioUpdateContext = createContext<any>( null ); // TODO: Properly fill out


function usePortfolio() {
  return useContext( PortfolioContext );
}

function usePortfolioUpdate() {
  return useContext( PortfolioUpdateContext );
}




interface IPortfolioContent {
  platformSelector: string;

  coachName: string;
  tagline: string;

  disciplines: any[]; // TODO: TYPE (IPortfolioDiscipline) -- Place in Shared Repo?
}


function PortfolioContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [ disciplines, setDisciplines ] = useState<any[]>( [] );
  const [ contentKeys, setContentKeys ] = useState<string[]>( [] );

  const [ selectedDiscipline, setSelectedDiscipline ] = useState<any | undefined>( undefined );
  const [ selectedContent, setSelectedContent ] = useState<any | undefined>( undefined );

  const [ coachData, setCoachData ] = useState<any | undefined>( undefined );



  useEffect( () => {

    const updateData = async () => {
      const portfolioData: IPortfolioContent = await fetchPortfolioData( "pivotalWisdom" );

      console.log( "portfolioData", portfolioData );

      setDisciplines( portfolioData.disciplines );
      setCoachData({ coachName: portfolioData.coachName, tagline: portfolioData.tagline });
    }

    updateData();
  }, []);


  useEffect( () => {
    if( !disciplines?.length ) return;

    setSelectedDiscipline( disciplines[0] );
  }, [disciplines]);



  useEffect( () => {
    if( !selectedDiscipline?.content.length ) return;

    const disciplineKeys = selectedDiscipline.content.map( (content: any) => content.selector );
    const contentKeys = ["all", ...disciplineKeys];

    setContentKeys( contentKeys );
    setSelectedContent( selectedDiscipline.content[0] );
  }, [selectedDiscipline]);



  // ... Updating State
  const updateSelectedDiscipline = ( disciplineSelector: string ) => {
    setSelectedDiscipline( disciplines.find( (d: any) => d.selector === disciplineSelector ) );

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_discipline_nav_button"
      },
      additionalDetails: {
        selectedDiscipline: disciplineSelector,
        selectedContent: selectedContent?.selector,
      }
    });
  }

  const updateSelectedContent = ( contentSelector: string ) => {
    setSelectedContent( selectedDiscipline.content.find( (c: any) => c.selector === contentSelector ) );

    reportInteraction({
      interactionType: "click", // InteractionType.CLICK, // TODO: Use once moved to shared repo
      interactionDetails: {
        elementId: "portfolio_content_nav_button"
      },
      additionalDetails: {
        selectedDiscipline: selectedDiscipline?.selector,
        selectedContent: contentSelector,
      }
    });
  }



  // ... Persisting State down into Children
  return (
    <PortfolioContext.Provider value={ {coachData, disciplines, selectedDiscipline, contentKeys, selectedContent} } >
      <PortfolioUpdateContext.Provider value={ {updateSelectedDiscipline, updateSelectedContent} } >
        {children}
      </PortfolioUpdateContext.Provider>
    </PortfolioContext.Provider>
  )
}















/* */
